/* Copy to clipboard*/
function copyToClipboard(content,onSuccess,onError) {
  navigator.clipboard.writeText(content).then(() => {
    if(onSuccess){
      onSuccess();
    }
    const msg = document.getElementById("copyMessage");
    msg.style.display = "block";
    setTimeout(() => {
      msg.style.display = "none";
    }, 1000);
    }).catch(err => {
      console.log("copy error：" + err);
      if(onError){
         onError();
      }
  });
}

/* Share to Socials */
function shareToSocials(url,callback){
    
}